import api from "Common/Client/Interceptor";

export const fetchData = async (id, token, completed) => {
  try {
    const response = await api.get(`/Training/Mentor/List?mentorId=${id}&completed=${completed}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching project data:", error);
    throw error;
  }
};

export const fetchProjectData = async (id, token) => {
  try {
    const response = await api.get(`/Training/Mentor/Projects/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching project data:", error);
    throw error;
  }
};

// export const assignTask = async (taskData, token) => {
//   try {
//     const response = await apiClient.post(`/InternshipProject/Mentor/AssignTask`, taskData, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//     return response.data
//   } catch (error) {
//     console.error('Error assigning task:', error)
//     throw error
//   }
// }

export const toggleResubmission = async (id, token) => {
  try {
    const response = await api.post(
      `/Training/Toggle-Resubmission?taskId=${id}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error toggling resubmission:", error);
    throw error;
  }
};

export const updateTrainingTimeline = async (trainingId, endDate) => {
  try {
    const response = await api.post(
      "/Training/Mentor/Training-Timeline-Update",
      {
        trainingId,
        endDate,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating timeline:", error);
    throw error;
  }
};

// export const fetchReports = async (memberId, token) => {
//   try {
//     const response = await api.get(`/InternshipStatusReport/student?memberId=${memberId}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//     return response.data
//   } catch (error) {
//     console.error('Error fetching reports:', error)
//     throw error
//   }
// }

export const fetchIssueAndReport = async (id, token) => {
  try {
    const response = await api.get(`/TrainingIsuue/Learner/List?memberId=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch view history", error);
    throw error;
  }
};
